<template>
  <span>
    <h2>Комментарии к {{ carrierName }}</h2>
    <el-card
      v-for="comment in commentsList"
      id="comment_card"
      :key="comment.id"
    >
      <div style="position: relative">
        <p class="date-text">
          Добавленно: {{ getDateOfCertainFormat(comment.created_at) }}
        </p>
        <div>
          <div class="title-block">
            <div>
              <h4>Комментарий:</h4>
            </div>
            <div>
              <div class="title-block">
                <h4 style="margin-right: 8px">Оценка:</h4>
                <span v-if="Boolean(comment.is_positive)">
                  <img src="@/assets/img/like.svg" alt="dislike" />
                </span>
                <span v-else>
                  <img src="@/assets/img/dislike.svg" alt="dislike" />
                </span>
              </div>
            </div>
          </div>
          <div
            :class="{
              positive: Boolean(comment.is_positive),
              negative: !Boolean(comment.is_positive),
            }"
          >
            <p>{{ comment.text }}</p>
          </div>
        </div>
      </div>
    </el-card>
  </span>
</template>

<script>
export default {
  name: 'CommentsFill',
  props: {
    commentsList: {
      type: Array,
      default: () => [],
    },
    carrierName: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="sass">
#comment_card
  font-family: 'Rubik', sans-serif
  margin-bottom: 20px
  box-shadow: none
  .date-text
    color: #909399
    padding: 0
    margin: 0
    margin-bottom: 4px
  .title-block
    padding: 0
    margin-bottom: 4px
    display: flex
    justify-content: space-between
    align-items: center
    h4
      padding: 0
      margin: 0
  .positive
    color: rgba(0, 0, 0, 0.47)
    background: rgba(66, 185, 131, .1)
    border-radius: 4px
    padding: 4px 8px
  .negative
    color: rgba(0, 0, 0, 0.47)
    background: rgba(214, 50, 0, .1)
    border-radius: 4px
    padding: 4px 8px
  &:hover
    transition: all 0.2s
    box-shadow: 0 2px 16px rgba(0, 0, 0, 0.12)
  .el-collapse
    border: none
    .el-collapse-item__wrap
      border: none
    .el-collapse-item__header
      color: #409EFF
      position: absolute
      right: 0
      top: -40px
      z-index: 2
      font-size: 14px
      border: none
      &.is-active
        top: auto
        bottom: -17px
        right: 0
        background: transparent
      span
        border-bottom: 1px solid
        line-height: 1
    .el-collapse-item__arrow
      display: none
</style>
